<script>
  import { onMount } from 'svelte';
  import * as d3 from 'd3';
  import { 
    gen_background_control, 
    gen_frames, 
    gen_sub_frames,
    set_frame_comparison_size, 
    gen_frame_comparison_plot,
    gen_time_control_view,
    gen_skeleton
  } from './FrameView.js'
  
  // Export let name
  let FrameView = undefined
  let benign_frame_view = undefined
  let benign_frame_control = undefined
  let benign_control_board = undefined
  let benign_frames = undefined
  let sub_benign_frames = undefined
  let frame_comparison = undefined
  let attacked_frame_view = undefined
  let attacked_frame_control = undefined
  let attacked_control_board = undefined
  let attacked_frames = undefined
  let sub_attacked_frames = undefined
  let time_view = undefined

  // Generate frame view
  onMount(async() => {
    gen_benign_frame_view()
    gen_frame_comparison_view()
    gen_attacked_frame_view()
    gen_time_view()
    gen_background_control('benign')
    gen_background_control('attacked')
  })

  // Generate benign frame view
  function gen_benign_frame_view() {

    // Benign frame view components
    benign_frame_view = d3.select(FrameView).select('#benign-frame-view')
    benign_frames = benign_frame_view.select('.frames')
    sub_benign_frames = benign_frame_view.select('.detailed-frames')

    // Frames
    gen_frames(benign_frames)

    // Add skeleton for overlap, separate view
    gen_skeleton()

  }

  // Generate frame comparison view
  function gen_frame_comparison_view() {

    // Frame comparison view components
    frame_comparison = d3.select(FrameView).select('#frame-comparison-view')

    // Size of frame comparison view
    set_frame_comparison_size(frame_comparison)
  
    // Generate comparison plot
    gen_frame_comparison_plot(frame_comparison)
  }

  // Generate attacked frame view
  function gen_attacked_frame_view() {

    // Benign frame view components
    attacked_frame_view = d3.select(FrameView).select('#attacked-frame-view')
    attacked_frames = attacked_frame_view.select('.frames')

    // Frames
    gen_frames(attacked_frames)
    
  }

  // Generate attacked congrol view
  function gen_attacked_frame_control() {
    attacked_control_board = d3.select(FrameView).select('#attacked-control-board')
    attacked_frame_control = attacked_frame_view.select('.background-control-view')
    gen_frame_control(attacked_frame_control)
    gen_frame_control_board(attacked_control_board)

  }

  // Generate time control view
  function gen_time_view() {
    time_view = d3.select('#time-view')
    gen_time_control_view(time_view)
  }

</script>

<style>

  #frame-view {
    text-align: left;
    margin: 10px;
    display: flex;
    flex-direction: column;
  }

  .background-control-view {
    color: #777777;
  }

  .check-option {
    display: inline-block;
    padding-right: 7px;
    padding-top: 2px;
    padding-bottom: 2px;
  }

  #time-bar {
    margin-top: 50px;
  }
</style>

<div id='frame-view' class='pose-view' bind:this={FrameView}>

  <!-- Benign frame -->
  <div id='benign-frame-view' class='pose-view'>

    <!-- Frame background control -->
    <div id='benign-background-control' class='background-control-view'>
      <div id='benign-background-frame' class='check-option'></div>
      <div id='benign-background-confidence' class='check-option'></div>
    </div>

    <!-- Frames -->
    <div id='benign-frames' class='frames'></div>
    <div id='benign-detailed-frames' class='detailed-frames'></div>

  </div>

  <!-- Frame comparison -->
  <div id='frame-comparison-view'>
  </div>

  <!-- Attacked frame -->
  <div id='attacked-frame-view' class='pose-view'>

    <!-- Frames -->
    <div id='attacked-detailed-frames' class='detailed-frames'></div>
    <div id='attacked-frames' class='frames'></div>

    <!-- Frame control -->
    <div id='attacked-background-control' class='background-control-view'>
      <div id='attacked-background-frame' class='check-option'></div>
      <div id='attacked-background-perturbation' class='check-option'></div>
      <div id='attacked-background-confidence' class='check-option'></div>
    </div>

  </div>

  <!-- Time control view -->
  <div id='time-view'>
    <div id='time-bar'></div>
    <div id='time-button'></div>
  </div>
    
</div> 

